import { defineStore } from "pinia"
import { fetchDashboardData } from "@/api/dashboard"
// import { fetchDashboardStat } from "@/api/dashboard"
// import { fetchProductData } from "@/api/product"
// import { fetchSingleProductData } from "@/api/product"
// import { reset } from "@/api/auth"

export const useAuthStore = defineStore("auth", {
  state: () => ({
    admin: null,
  }),

  actions: {
    async loadDashboardData() {
      try {
        const res = await fetchDashboardData()
        this.admin = res.data.data
      } catch (error) {
        if (error.response?.status === 403) {
            return null
        }

        throw error
      }
    },

    // async loadPartnerStat() {
    //   const res = await fetchDashboardStat()
    //   this.stat = res.data.data
    // },

    // async loadProducts() {
    //   try {
    //     const res = await fetchProductData()
    //     this.products = res.data.data.products || []
    //     //console.log("Products loaded:", res.data.data)
    //   } catch (error) {
    //     console.error("Failed to load products:", error)
    //     this.products = []
    //   }
    // },

    // async loadSingleProduct(id) {
    //   try {
    //     const res = await fetchSingleProductData(id)
    //     this.singleProduct = res.data.data
    //     //console.log(res.data.data)
    //   } catch (error) {
    //     console.error("Failed to load product:", error)
    //   }
    // },

    // async resetUserPassword(payload) {
    //   try {
    //     const res = await reset(payload)
    //     this.reset = res.data
    //     return res.data // successful response
    //   } catch (error) {
    //     console.error("Failed to Reset:", error)
    //     // important: rethrow so component can catch it
    //     throw error
    //   }
    // },

    logout() {
      localStorage.removeItem("token")
      // remove auto logout flag
      localStorage.removeItem("useAutoLogout");

      // optional: clear last route too
      localStorage.removeItem("lastRoute");
      this.admin = null
      
    }
  }
})
